import * as React from 'react'
import { Link } from './Link'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const LinkExamples = () => {
  return (
    <div className="LinkExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <Link title="title" />
      </Provider>
    </div>
  )
}
